import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { PrimaryLayout } from '../Layouts';
import notify from 'devextreme/ui/notify';


function PrimaryTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    
    const handleFieldChange = useCallback(() => {
    }, []);
        const handleSelectionChange = useCallback(() => {
    }, []);
    const handleprimaryFormLoad = useCallback(() => {
       props.primaryFormLoad();

    }, []);
    const handleFocusIn = useCallback((name, e) => {
        let message = '';
        if (name === 'SHOWCURRENTLOTONLY') {
            message =
                'This option determines how many records are retrieved when EDITING the "LOT" record ' +
                'during an edit on the fly (Right Click on Bino) or double click on Lot record in ' +
                'the (Item Master Screen , bottom Lot Tab). '+
            'If you choose the "Only Show Selected Lot" option, the current lot record selected will be retrieved, ' +
                'and you will NOT be able to view next and previous lot records unless you do another "FIND". '+
            'If you choose the "Show All Lot Records" option, all the lot records for the selected item will be retrieved. ' +
                'However this option possibly can take longer time to load the lot entry form  based on ' +
                'number of lot records you have for the item. ';
        }
        if (name === 'SHOWCURRENTSUBLOTONLY') {
            message =
                'This option determines how many records are retrieved when EDITING the "SUBLOT" record ' +
                'during an edit on the fly (Right Click on Bino) or double click on sublot record in ' +
                'the (Lot Master Screen , bottom sublot Tab). '+
            'If you choose the "Only Show Selected Sublot" option, the current sublot record selected will be retrieved, ' +
                'and you will NOT be able to view next and previous sublot records unless you do another "FIND". '+
            'If you choose the "Show All Sublot Records" option, all the sublot records for the selected lot will be retrieved. ' +
                'However, this option possibly can take a longer time to load the sublot entry form  based on ' +
                'number of sublot records you have for the lot. ';
        }
        if (message) {
            notify({ message, width: 600, height: 200 }, 'warning', 6000);
        }
    });
    return (
        <div style={{marginTop:"10px"}}>
            <FormField
                currrentUser={currentUser}
                layoutId='2EEBBFF4-4BC2-43F2-BE6A-97600B0D85AE'
                layoutName='WMPrimarySetupForm'
                defaultFormSchema={PrimaryLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleprimaryFormLoad}
                handleSelectedItemChange={handleSelectionChange}
                handleFocusItemIn={handleFocusIn}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTab);
